var _styled;

import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import * as COLOUR from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledRelatedItems = styled('div')((_styled = {
  borderTop: "10px solid " + COLOUR.BLUE,
  paddingTop: SPACING.SCALE_1,
  width: '100%'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled['> h3'] = {
  marginBottom: SPACING.SCALE_2
}, _styled['> ul'] = {
  marginBottom: SPACING.SCALE_4,
  '> li': {
    marginBottom: "calc(" + SPACING.SCALE_2 + " + 2px)"
  }
}, _styled));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * import Header from '@govuk-react/header';
 * import UnorderedList from '@govuk-react/unordered-list';
 * import ListItem from '@govuk-react/list-item';
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorTag = asAnchor('a');
 *
 * <RelatedItems>
 *   <Header level={3}>Example header</Header>
 *   <UnorderedList listStyleType="none">
 *     <ListItem>
 *       <AnchorTag href="https://example.com">Link A</AnchorTag>
 *     </ListItem>
 *   </UnorderedList>
 * </RelatedItems>
 * ```
 *
 * ### References:
 * - https://govuk-static.herokuapp.com/component-guide/related_items
 *
 * ### TODO:
 * - Replace CSS selectors with imported components
 *
 */

var RelatedItems = function RelatedItems(props) {
  return React.createElement(StyledRelatedItems, props);
};

export default withWhiteSpace({
  marginBottom: 0
})(RelatedItems);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/related-items/es/index.js
// module id = 280
// module chunks = 0